eta ki pura replace dibo eta diye?

<template>
    <div class="about">
        <div class="row student-profile">
            <div class="col-md-12 mb-3">
                <div class="row">
                    <div class="col-md-3 mb-3 col-6">
                        <div class="card card-body counter-box">
                            <router-link
                                :to="{
                                    name: 'student.course_file',
                                    params: {
                                        classID: $parent.data.std_class_id,
                                        sectionID: $parent.data.section_id
                                    }
                                }"
                            >
                                <h3 class="couter_icon3"><i class="fa fa-calendar"></i></h3>
                                <h4>
                                    {{ lesson_plan.total_lesson > 0 ? lesson_plan.total_lesson : 0 }} <br>
                                    <span>Lesson Plan</span>
                                </h4>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-md-6 col-xl-6 mb-3">
                <div class="card daily-sales">
                    <div class="card-body">
                        <div class="table-header mb-3 d-flex justify-content-between">
                            <h3>Lesson Plan</h3>
                            <router-link
                                v-if="$parent.data"
                                class="btn btn-success py-1 px-3"
                                :to="{ name: 'student.course_file', params: { classID: $parent.data.std_class_id, sectionID: $parent.data.section_id } }"
                            >
                                View all
                            </router-link>
                        </div>
                        <form class="row align-items-end mb-3" @submit.prevent="lessonPlanSearch">
                            <div class="form-group col-md-4 mb-2">
                                <label class="col-form-label-sm font-weight-normal mb-0">Teacher</label>
                                <select
                                    class="form-control form-control-sm"
                                    v-model="lesson_search.teacher_id"
                                    @change="lessonPlanSearch"
                                >
                                    <option :value="null">All Teacher</option>
                                    <option
                                        v-for="teacher in lesson_filter_options.teachers"
                                        :key="teacher.id"
                                        :value="teacher.id"
                                    >
                                        {{ teacher.name }}
                                    </option>
                                </select>
                            </div>
                            <div class="form-group col-md-4 mb-2">
                                <label class="col-form-label-sm font-weight-normal mb-0">Subject</label>
                                <select
                                    class="form-control form-control-sm"
                                    v-model="lesson_search.subject_id"
                                    @change="lessonPlanSearch"
                                >
                                    <option :value="null">All Subject</option>
                                    <option
                                        v-for="subject in lesson_filter_options.subjects"
                                        :key="subject.id"
                                        :value="subject.id"
                                    >
                                        {{ subject.name }}
                                    </option>
                                </select>
                            </div>
                            <div class="form-group col-md-2 mb-2">
                                <label class="col-form-label-sm font-weight-normal mb-0">Limit</label>
                                <select
                                    class="form-control form-control-sm"
                                    v-model.number="lesson_search.pagination"
                                    @change="lessonPlanSearch"
                                >
                                    <option v-for="limit in lesson_limits" :key="limit" :value="limit">
                                        {{ limit }}
                                    </option>
                                </select>
                            </div>
                            <div class="form-group col-md-2 mb-2">
                                <button type="button" class="btn btn-sm btn-secondary" @click="resetLessonPlanSearch">
                                    Reset
                                </button>
                            </div>
                        </form>
                        <table class="table table-bordered" style="margin: -6px">
                            <thead style="background: #17a2b8">
                            <tr>
                                <th>Teacher</th>
                                <th>Title &amp; Subject</th>
                                <th>Uploaded Date</th>
                            </tr>
                            </thead>
                            <tbody v-if="lesson_plan.datas && Object.keys(lesson_plan.datas).length > 0">
                            <tr v-for="(data, index) in lesson_plan.datas" :key="index">
                                <td>{{ data.teacher ? data.teacher.name : "" }}</td>
                                <td>
                                    {{ data.title }}<br/>
                                    <b v-if="data.subject">{{ data.subject.name }}</b>
                                </td>
                                <td>{{ data.created_at | formatDate }}</td>
                            </tr>
                            </tbody>
                        </table>

                        <div v-if="lesson_plan.datas && Object.keys(lesson_plan.datas).length == 0" class="text-center mt-5">
                            <span>No data found!</span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-md-6 col-xl-6 mb-3">
                <div class="card Monthly-sales">
                    <div class="card-body">
                        <div class="table-header mb-3 d-flex justify-content-between">
                            <h3>Attendance Status</h3>
                            <select
                                v-if="$parent.data"
                                v-on:change="getAttendance($parent.data.id, $event.target.value)"
                                class="form-control col-6"
                            >
                                <option value="">Select month</option>
                                <option value="01">January</option>
                                <option value="02">February</option>
                                <option value="03">March</option>
                                <option value="04">April</option>
                                <option value="05">May</option>
                                <option value="06">June</option>
                                <option value="07">July</option>
                                <option value="08">August</option>
                                <option value="09">September</option>
                                <option value="10">October</option>
                                <option value="11">November</option>
                                <option value="12">December</option>
                            </select>
                        </div>
                        <div id="chart">
                            <apexchart
                                type="pie"
                                width="380"
                                :options="chartOptions"
                                :series="series"
                            ></apexchart>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-md-5 col-xl-5 mb-3">
                <div class="card Monthly-sales">
                    <div class="card-body">
                        <div class="table-header mb-3 d-flex justify-content-between">
                            <h3>Recent Notice</h3>
                        </div>
                        <div class="recent_notice">
                            <marquee
                                direction="up"
                                scrollamount="2"
                                onmouseout="start()"
                                onmouseover="stop()"
                                height="100%"
                                behavior="scroll"
                            >
                                <ul class="list-group">
                                    <li
                                        v-for="(general, generalNotice) in Notices['academic']"
                                        :key="generalNotice"
                                    >
                                        <div style="display: flex; margin-bottom: 5px">
                                            <div>
                                                <router-link
                                                    v-if="general.type === 'content'"
                                                    :to="{
                                                        name: 'notice.detail',
                                                        params: {
                                                            category: general.category,
                                                            slug: general.slug
                                                        }
                                                    }"
                                                >
                                                    <h5 class="notice_cat">
                                                        <img
                                                            v-if="general.new == 'yes'"
                                                            style="height: 30px; width: 30px"
                                                            :src="$root.baseurl + '/img/blingking.gif'"
                                                            alt="image"
                                                        />
                                                        {{ general.title }}
                                                        <span
                                                            class="pull-right"
                                                            style="font-size: 10px; color: red"
                                                            v-if="general.updated != '0' && general.new == 'no'"
                                                        >
                                                            Notice has been updated {{ general.updated }} days ago
                                                        </span>
                                                    </h5>
                                                </router-link>
                                                <a
                                                    v-else
                                                    :href="general.FullUrl + general.file"
                                                    target="_blank"
                                                >
                                                    <h5 class="notice_cat" style="font-size: 14px">
                                                        <img
                                                            v-if="general.new == 'yes'"
                                                            style="height: 30px; width: 30px"
                                                            :src="$root.baseurl + '/img/blingking.gif'"
                                                            alt="image"
                                                        />
                                                        {{ general.title }}
                                                        <span
                                                            class="pull-right"
                                                            style="font-size: 10px; color: red"
                                                            v-if="general.updated != '0' && general.new == 'no'"
                                                        >
                                                            Notice has been updated {{ general.updated }} days ago
                                                        </span>
                                                    </h5>
                                                </a>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </marquee>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-md-7 col-xl-7 mb-3">
                <div class="card daily-sales">
                    <div class="card-body">
                        <div class="table-header mb-3 d-flex justify-content-between">
                            <h3>Today Class Routine</h3>
                        </div>
                        <h5 class="text-info">{{ todayDate() }}</h5>
                        <div class="row" v-if="data.routineDetails">
                            <div
                                class="col-md-4 border today-routine text-center"
                                v-for="(routine,index) in data.routineDetails"
                                :key="index"
                            >
                                <slot v-if="routine.subject && routine.status == null || routine.status">
                                    <small class="d-block"><b>{{ routine.subject }}</b></small>
                                    <small class="d-block">{{ routine.teacher }}</small>
                                    <small class="d-block">
                                        Summer[ <small>{{ routine.duration.start }}</small> - <small>{{ routine.duration.end }}</small> ]<br>
                                        Winter[ <small>{{ routine.duration.winter_start }}</small> - <small>{{ routine.duration.winter_end }}</small> ]<br>
                                    </small>
                                </slot>
                                <slot v-else>
                                    <span class="d-flex justify-content-center">OFF</span>
                                </slot>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--Welcome-text-->
    </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import Banner from "./../pages/Banner.vue";
import image from "../../../assets/img/avatar.png";
import moment from "moment";

const breadcumb = [
    {
        title: "Applicant Login",
    },
];

export default {
    name: "Dashboard",
    components: { Banner, apexchart: VueApexCharts },
    data() {
        return {
            lesson_loader: false,
            lesson_plan: { loader: false, datas: [], total_lesson: "" },
            lesson_filter_options: { teachers: [], subjects: [] },
            lesson_limits: [20, 50, 10, 150, 200],
            lesson_search: {
                teacher_id: null,
                subject_id: null,
                pagination: 20
            },
            Notices: [],
            attendances: {},
            headerCountData: {},
            data: { routineDetails: {} },
            image_src: image,
            breadcumb: breadcumb,
            series: [0, 0],
            chartOptions: { labels: ["Absent", "Present"] },
            count: 0
        };
    },
    methods: {
        todayDate() {
            return moment().format("dddd - MMM D, YYYY");
        },
        get_datas(pageindex, date = null) {
            this.lesson_loader = true;
            axios
                .get("/student/lesson_plan", { params: this.lesson_search })
                .then((respons) => {
                    this.is_hit = true;
                    this.lesson_plan.datas = respons.data.lesson_plan || [];
                    this.lesson_plan.total_lesson = respons.data.total_lesson || 0;
                    if (respons.data.filters) {
                        this.lesson_filter_options = respons.data.filters;
                    }
                    this.lesson_loader = false;
                })
                .catch((error) => {
                    console.log(error);
                    this.lesson_loader = false;
                })
                .then(() => {
                    this.lesson_loader = false;
                });
        },
        lessonPlanSearch() {
            this.get_datas();
        },
        resetLessonPlanSearch() {
            this.lesson_search.teacher_id = null;
            this.lesson_search.subject_id = null;
            this.lesson_search.pagination = 20;
            this.get_datas();
        },
        get_notice() {
            this.$root.loading = true;
            axios
                .get("/home/type/noticecat")
                .then((respons) => {
                    this.Notices = respons.data.noticecat;
                    this.$root.loading = false;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        getAttendance(id, month = null) {
            this.$root.loading = true;
            axios
                .get("dashboardAttendance/" + id, { params: { month: month } })
                .then(response => {
                    this.attendances = response.data;
                    this.series = [
                        response.data.absend ? response.data.absend.length : 0,
                        response.data.present ? response.data.present.length : 0
                    ];
                })
                .catch(error => {
                    console.log(error);
                })
                .then(() => {
                    this.$root.loading = false;
                });
        },
        getClassRoutine() {
            axios
                .get("/dashboard-class-routine/" + moment().format("ddd"))
                .then(response => {
                    this.data.routineDetails = response.data;
                });

            this.$root.loading = false;
        }
    },
    mounted() {
        this.$root.loading = false;
    },
    created() {
        setTimeout(() => {
            this.get_datas();
        }, 1500);

        this.get_notice();
        this.getAttendance("get-attendance");
        this.getClassRoutine();
    },
    updated() {
        if (Object.keys(this.attendances).length < 1) {
            if (this.count <= 0) {
                this.getAttendance("get-attendance");
            }
            this.count++;
        }
    }
};
</script>

<style scoped>
.student-profile .table th {
    font-size: 14px;
    padding: 5px 10px;
    color: #fff;
}

.row.student-profile .card {
    height: 100%;
}

.recent_notice ul li a {
    line-height: 15px;
}

.today-routine small {
    font-size: 12px;
}
</style>
